// client/src/services/serviceService.js
import axios from '../utils/axiosConfig';

export const listServices = () => axios.get('/services').then(r => r.data.services);
